/**
 * Created by yangjiao on 2020/4/20.
 */
import request from './http'
import { mock } from 'mockjs'
const baseUrl = '/apass-base'
// 获取应用管理列表
export const getApplicationList = (data: any) =>
  request({
    url: baseUrl + '/api/application/pageList',
    method: 'get',
    params: data
  })
export const getApplicationStatusById = (data: any) =>
  request({
    url: baseUrl + '/api/application/update',
    method: 'post',
    data
  })
export const deleteDeptById = (data: any) =>
  request({
    url: baseUrl + '/api/department/delete/' + data.id,
    method: 'get'
  })
export const saveAddWorker = (data: any) =>
  request({
    url: baseUrl + '/api/user/insert',
    method: 'post',
    data
  })
export const saveEditWorker = (data: any) =>
  request({
    url: baseUrl + '/api/user/update',
    method: 'post',
    data
  })
export const getFirmMessage = () =>
  request({
    url: baseUrl + '/api/company/information',
    method: 'get'
  })
export const getWorkerByDepId = (data?: any) =>
  request({
    url: baseUrl + '/api/user/search',
    method: 'post',
    data
  })
export const getDeptList = () =>
  request({
    url: baseUrl + '/api/department/tree',
    method: 'get'
  })
export const movetDeptList = (data: any) =>
  request({
    url: baseUrl + '/api/department/move',
    method: 'post',
    data
  })
export const addDept = (data: any) =>
  request({
    url: baseUrl + '/api/department/insert',
    method: 'post',
    data
  })
export const editDept = (data: any) =>
  request({
    url: baseUrl + '/api/department/update',
    method: 'post',
    data
  })
export const importWork = (data?: any) =>
  request({
    url: baseUrl + '/api/user/upload',
    method: 'post',
    data
  })
